import { useState, useRef, useEffect } from "react";
import './Dashboard.css'
import Loader from "../../Components/Loader/Loader";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartValueAxisItem,
    ChartValueAxis,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartTooltip,
} from "@progress/kendo-react-charts";
import {  Form, Select} from "antd";
import '@progress/kendo-theme-default/dist/all.css';
import { useForm } from "antd/es/form/Form";
import moment from 'moment';
import axios from "axios";


function Dashboard() {
    const [BasicInsert] = useForm();
    const UserDetails = useState(JSON.parse(sessionStorage.getItem("UserInfo")))
    const [Loader_Show, setLoader_Show] = useState(false)
    const [AllPlantData, setAllPlantData] = useState([])
    const [AllDashboardData, setAllDashboardData] = useState([])
    const [DashboardCount, setDashboardCount] = useState({})
    const [DashPermitCount, setDashPermitCount] = useState([])
    const [PlantBasedCount, setPlantBasedCount] = useState([])
    const formRef = useRef(null)
    const countData = PlantBasedCount;
    const maxCount = Math.max(...countData.map(item => item.count));

    useEffect(() => {
        if (UserDetails[0]?.designation === "CO EHS") {
            GetAllPlants()
            let URL = process.env.REACT_APP_PERMIT + "/Master/DashBoardSafteyHead?empid=" + UserDetails[0]?.employeeId + "&year=" + "2025-01-01"
            axios.get(URL)
                .then((Res) => {
                    let allDashboardDatas = {};
                    allDashboardDatas = Res.data;
                    let overAllStatusCount = Res.data.status
                    if (overAllStatusCount !== undefined && Object.keys(overAllStatusCount).length > 0) {
                        setDashboardCount(overAllStatusCount);
                    } else {
                        setDashboardCount({})
                    }

                    let overAllCount = Res.data.permitdata
                    if (overAllCount.length > 0) {
                        setDashPermitCount(overAllCount)
                    } else {
                        setDashPermitCount([])
                    }

                    let PlantBasedChart = Res.data.monthWiseData
                    if (PlantBasedChart.length > 0) {
                        setPlantBasedCount(PlantBasedChart)
                    } else {
                        setPlantBasedCount([])
                    }

                    // console.log(Res.data, "Co EHS Data")
                    setAllDashboardData(Res.data);
                })
                .catch((Error) => {
                    console.log(Error, "Error GetNatureofwork");
                });
        } else {
            GetDasboardCount()
            GetPermitBasedChart()
            GetPlantBasedChart()
        }
    }, [])

    const GetAllPlants = () => {
        let URL = process.env.REACT_APP_PERMIT + "/Master/AllPlant"
        axios.get(URL).then((Response) => {
            if (Response) {
                setAllPlantData(Response.data)
            }
        }).catch((Error) => {
            console.log(Error, "Error GetNatureofwork")
        })
    };

    const PlantMasterChange = (event) => {
        let data = event;
        if (typeof data === 'number' && data > 0) {
            data = data;
        } else if (data === " " || data === "") {
            data = " ";

            let URL = process.env.REACT_APP_PERMIT + "/Master/DashBoardSafteyHead?empid=" + UserDetails[0]?.employeeId + "&year=" + "2025-01-01"
            axios.get(URL)
                .then((Res) => {
                    let overAllStatusCount = Res.data.status
                    if (overAllStatusCount !== undefined && Object.keys(overAllStatusCount).length > 0) {
                        setDashboardCount(overAllStatusCount);
                    } else {
                        setDashboardCount({})
                    }

                    let overAllCount = Res.data.permitdata
                    if (overAllCount.length > 0) {
                        setDashPermitCount(overAllCount)
                    } else {
                        setDashPermitCount([])
                    }

                    let PlantBasedChart = Res.data.monthWiseData
                    if (PlantBasedChart.length > 0) {
                        setPlantBasedCount(PlantBasedChart)
                    } else {
                        setPlantBasedCount([])
                    }
                })
                .catch((Error) => {
                    console.log(Error, "Error GetNatureofwork");
                });

        } else {
            data = null;
        }
        if (data !== null && data !== undefined) {

            let URL = process.env.REACT_APP_PERMIT + "/Master/DashBoardSafteyHead?empid=" + UserDetails[0]?.employeeId + "&year=" + "2025-01-01" + "&PlantId=" + data
            axios.get(URL)
                .then((Res) => {
                    let overAllStatusCount = Res.data.status
                    if (overAllStatusCount !== undefined && Object.keys(overAllStatusCount).length > 0) {
                        setDashboardCount(overAllStatusCount);
                    } else {
                        setDashboardCount({})
                    }

                    let overAllCount = Res.data.permitdata
                    if (overAllCount.length > 0) {
                        setDashPermitCount(overAllCount)
                    } else {
                        setDashPermitCount([])
                    }

                    let PlantBasedChart = Res.data.monthWiseData
                    if (PlantBasedChart.length > 0) {
                        setPlantBasedCount(PlantBasedChart)
                    } else {
                        setPlantBasedCount([])
                    }
                })
                .catch((Error) => {
                    console.log(Error, "Error GetNatureofwork");
                });
        } else {
            console.log("Invalid event data");
        }
    };

    const GetDasboardCount = () => {
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetDashBoard?EmpId=" + UserDetails[0]?.employeeId + "&Division=" + UserDetails[0]?.divisionID
        axios.get(URL).then((Response) => {
            if (Response) {
                setDashboardCount(Response.data)
            }
        })
    }

    const GetPermitBasedChart = () => {
        let data = {
            fromdate: "",
            todate: ""
        };
        let input = {
            division: UserDetails[0]?.divisionID,
            empid: UserDetails[0]?.employeeId,
            fromdate: data.fromdate || null,
            todate: data.todate || null
        };
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetPermitBasedDashBoard"
        axios.post(URL, input).then((Response) => {
            if (Response) {
                setDashPermitCount(Response.data)
            }
        })
    };

    const GetPlantBasedChart = () => {
        let date = moment().format("YYYY-MM-DD");
        let URL = process.env.REACT_APP_PERMIT + "/Master/GetMonthWiseDAta?year=" + date + "&EmpId=" + UserDetails[0]?.employeeId + "&Division=" + UserDetails[0]?.divisionID
        axios.get(URL).then((Response) => {
            if (Response) {
                setPlantBasedCount(Response.data)
                // console.log(Response.data, "PieCharCount")
            }
        })
    }

    const CustomTooltip = (props) => {
        let data = {}
        data = props;
        return (
            <div>
                {data?.point?.category}: {data?.point?.value}
            </div>
        );
    };


    const colorMapping = {
        "Total": "White",
        "Draft": "#D3D3D3",
        "Approval Pending": "#EEF36A",
        "work Inprogress": "#edae49",
        "Closed": "Grey",
        "Deferred": "#dab785",
        "Escalation": "#fe5f55",
        "Extension": "#6d597a",
        "Rejected": "#823038"
    };

    const transformKeys = (data) => {
        return {
            "Total Permit": data.total,
            "Draft": data.draft,
            "Approval Pending": data.pendingApproval,
            "work Inprogress": data.workinInprogress,
            "Closed": data.closed,
            "Deferred": data.deferred,
            "Escalation": data.escalation,
            "Extension": data.extension,
            "Rejected": data.rejected,
        };
    };
    const transformedDatas = transformKeys(DashboardCount);

    return (
        <>
            {Loader_Show && <Loader />}
            <div className="DashboardMainClass">
                {UserDetails[0]?.designation === "CO EHS" &&
                    <Form ref={formRef} form={BasicInsert} layout="vertical">
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-3 col-sm-12">
                                <div className="FormCard">
                                    <Form.Item name="Plant">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                            <label style={{ marginRight: '1%', fontWeight: 'bold' }}>Plant</label>
                                            <Select
                                                defaultValue={" "}
                                                onChange={PlantMasterChange}
                                                style={{ width: '100%' }}
                                                placeholder="Select Plant"
                                            >
                                                <Select.Option value={" "}>
                                                    {"All"}
                                                </Select.Option>

                                                {AllPlantData.length > 0 &&
                                                    AllPlantData.map((Item, index) => (
                                                        <Select.Option key={index} value={Item.id}>
                                                            {Item.plantType}
                                                        </Select.Option>
                                                    ))}
                                            </Select>
                                        </div>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </Form>
                }
                <div className="row">
                    <div className="row">
                        <div className="flex-container">
                            {Object.keys(transformedDatas).map((item) => (
                                <div className="flex-item" key={item}>
                                    <div className="Glasscard" key={item} style={{ backgroundColor: colorMapping[item] }}>
                                        {item}
                                        <h2 className="CountClass">{transformedDatas[item]}</h2>
                                    </div>
                                </div>
                            ))}
                        </div><br />
                    </div>
                    <div className="col-md-6">
                        <h5 style={{ display: "flex", alignItems: "center", color: "black" }}>OverAll Permit Counts</h5>
                        <Chart style={{ overflow: "auto" }}>
                            <ChartTooltip render={CustomTooltip} />
                            <ChartLegend position="left" />
                            <ChartSeries>
                                <ChartSeriesItem
                                    type="pie"
                                    data={DashPermitCount.map(item => ({ category: item.permitName, value: item.count }))}
                                    name="Permit Distribution"
                                />
                            </ChartSeries>
                        </Chart>
                        <br />
                    </div>
                    <div className="col-md-6">
                        <div >
                            <h5 style={{ display: "flex", alignItems: "center", color: "black", marginTop: "1%" }}>Month Wise Permits</h5>
                            <Chart>
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem labels={{
                                        format: "d",
                                        rotation: "auto",
                                    }} title={{
                                        text: "Months",
                                    }}
                                        categories={PlantBasedCount?.map((item) => { return item.monthName })}
                                    />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem majorUnit={10} max={maxCount + 10} labels={{ format: "{0}" }} />
                                </ChartValueAxis>
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="line"
                                        data={PlantBasedCount.map((item) => { return item.count })}
                                    />
                                </ChartSeries>
                                <ChartTooltip />
                            </Chart>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Dashboard;